Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.ChartViewFactory
  constructor: (session) ->
    CHARTS = CustomerVisualMode.Charts
    @factories = [
      new CHARTS.DefaultChartViewFactory(session, CHARTS.TicketCountChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.OperationCurrentStatusChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.FirstMetricsForTicketsCreatedInRange),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.FirstMetricsCalculatedInRange),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.AverageReplyTimePerAgentBarChart),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.AverageHandleAfterAssignedTimePerAgentChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.WomCountChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.FirstHumanResponseSinceFirstHumanAssignationChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.AverageFirstBotResponseChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.BotCheckpointsChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.BotAverageInteractionTimeChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.TicketInteractionsAverageChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.ManagementTypesChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.RecontactMetricChartView),
      new CHARTS.DefaultChartViewFactory(session, CHARTS.TimeMetricChartView),
      new CHARTS.SingleDimensionViewFactory(session),
      new CHARTS.CrossDimensionViewFactory(session),
      new CHARTS.InvalidChartViewFactory
    ]

  create: (widget, data, isReadOnly, isResponsive) ->
    factory = @_findFactory(widget)
    return null unless factory

    factory.create(widget, data, isReadOnly, isResponsive)

  _findFactory: (widget) ->
    foundFactory = _.find(@factories, (factory) -> factory.canHandle(widget))
    @_logMissingChart(widget) unless foundFactory
    foundFactory

  _logMissingChart: (widget) ->
    error = "Could not find view for widget #{widget.get('type')}"
    jsLogger.error(error)
